<template>
    <v-tabs v-bind="$attrs" grow hide-slider class="v-tabs--solid">
        <slot />
    </v-tabs>
</template>

<script>
export default {
    props: {},
    components: {},
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.v-tabs--solid {
    ::v-deep {
        .v-tabs-bar {
            height: auto;
        }

        .v-tab {
            height: var(--btn-height-xxl);
            font-size: var(--btn-font-size-xxl);
            color: var(--v-grey-base);
            background-color: var(--v-grey-lighten5);
            border-color: var(--v-grey-lighten5);
            padding: 0 10px;
            &--active {
                color: #fff !important;
                font-weight: 700;
                background-color: var(--v-secondary-base) !important;
                border-color: var(--v-secondary-base) !important;
            }
        }
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .v-tabs--solid {
        ::v-deep {
            .v-tab {
                font-size: 1.8rem;
            }
        }
    }
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}
</style>
